import { CUSTOMER_TYPES } from '../../../../../constants/reviews';

export const LEGAL_OPTIONS = [
  {
    label: 'Для физлиц',
    value: CUSTOMER_TYPES.Individuals,
  },
  {
    label: 'Для бизнеса',
    value: CUSTOMER_TYPES.Businesses,
  },
];
